import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'edit-data',
  templateUrl: './edit-data.component.html',
  styleUrls: ['./edit-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class GETEditDataComponent implements OnInit {
    @Input() dataType = 'text';
    @Input() value: string;
    @Output() valueChanged: EventEmitter<string> = new EventEmitter();
    @Output() clickOut: EventEmitter<string> = new EventEmitter();
    initialValue: string;
    showSaveButton = false;
    showCancelButton = false;
    @Input() saving = false;
    unsavedData = false;
    @Input() canEdit = false;
    @Input() inputId: string;
    @Input() loading = false;
    @Input() vertResizeOnly = false;
    @Input() placeholderText = '';

  constructor() { }

  ngOnInit() {
      this.initialValue = this.value;
  }

  cancel() {
      this.value = this.initialValue;
      this.showCancelButton = false;
      this.showSaveButton = false;
      this.unsavedData = false;
  }

  // added to enable two way binding
  onValueChanged(event){
      this.valueChanged.emit(event);
  }

  saveChange(event) {
      if (this.value !== this.initialValue) {
          this.valueChanged.next(this.value);
          this.unsavedData = false;
          this.initialValue = this.value;
          this.showCancelButton = false;
          this.showSaveButton = false;
      }
  }

  onFocus() {
      this.showSaveButton = true;
      this.showCancelButton = true;
  }

  onFocusOut() {
      this.clickOut.next(this.value);
      if (this.initialValue === this.value) {
          this.showSaveButton = false;
          this.showCancelButton = false;
          this.unsavedData = false;
      } else {
        this.unsavedData = true;
      }

  }
}
